"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _form = _interopRequireDefault(require("../../form"));
const ColumnCheckbox = _ref => {
  let {
    checked,
    indeterminate,
    onChange
  } = _ref;
  const onCheckboxChange = (newValue, event) => {
    if ((0, _ark.isFunction)(onChange)) onChange(newValue, event);
  };
  return /*#__PURE__*/_react.default.createElement(_form.default.Group, {
    className: "tableCheckbox"
  }, /*#__PURE__*/_react.default.createElement(_form.default.Checkbox, {
    checked: checked,
    onChange: onCheckboxChange
  }));
};
process.env.NODE_ENV !== "production" ? ColumnCheckbox.propTypes = {
  checked: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : void 0;
ColumnCheckbox.defaultProps = {
  checked: false,
  indeterminate: false,
  onChange: undefined
};
var _default = exports.default = ColumnCheckbox;